/**
 * Compliance Agent (Sentinel) findings.
 *
 * Wraps `GET /api/v1/compliance-agent/findings` — runs Sentinel's
 * deterministic gather phase against this org and returns structured
 * findings grouped by category. Cheap (~SQL only, no LLM calls).
 */
import client from "./client";

export interface ComplianceFinding {
  category: string;
  severity?: "critical" | "warning" | "info";
  message?: string;
  // Findings are open-shape — different categories carry different
  // fields. Common ones:
  employee_id?: string;
  employee_name?: string;
  document_name?: string;
  due_date?: string;
  days_until?: number;
  // ...everything else surfaces verbatim.
  [key: string]: unknown;
}

export interface ComplianceReport {
  generated_at: string;
  summary: {
    total: number;
    critical: number;
    warning: number;
    info: number;
  };
  category_counts: Record<string, number>;
  findings: ComplianceFinding[];
  raw: Record<string, unknown>;
}

export async function getComplianceFindings(): Promise<ComplianceReport> {
  const res = await client.get<ComplianceReport>(
    "/compliance-agent/findings",
  );
  return res.data;
}
